import { DocumentExporterService, IInsightBoardPdfQuery, IPdfPreferences } from "@gtmhub/document-exporter/document-exporter-service";
import { IComponentOptions } from "angular";
import { triggerFileDownload } from "@gtmhub/shared/dom";
import { IIndicator } from "@gtmhub/error-handling";
import debounce from "lodash.debounce";

const defaultPdfPreferences: IPdfPreferences = {
  isLandscape: false,
  margins: [0, 0, 0, 0],
  paperSize: "A4",
  scale: 1,
};

export type IPdfPreviewResolve = {
  query: IInsightBoardPdfQuery;
  title: string;
};

export class PdfPreviewCtrl {
  resolve: IPdfPreviewResolve;
  close: () => void;
  dismiss: () => void;

  pdfLink: string;
  pdfFile: Blob;
  preferences: IPdfPreferences;
  margins: number;
  pdfQuery: IInsightBoardPdfQuery;
  indicators: {
    recreating: IIndicator;
  };
  recreatePreviewDebounced: () => void;

  static $inject = ["DocumentExporterService", "$sce"];

  paperSizes = ["A3", "A4", "A5", "A6", "Letter", "Legal", "Tabloid"];

  constructor(private documentExporterService: DocumentExporterService) {}

  $onInit() {
    this.indicators = {
      recreating: { progress: true },
    };

    this.recreatePreviewDebounced = debounce(this.recreatePreview, 500);

    this.pdfQuery = this.resolve.query;
    this.margins = 0;
    this.preferences = defaultPdfPreferences;
    this.pdfQuery.preferences = this.preferences;
    this.generatePdfPreview();
  }

  downloadGeneratedPdf = () => {
    const fileTitle = `${this.resolve.title}_${new Date().toLocaleDateString()}.pdf`;
    triggerFileDownload(this.pdfFile, fileTitle);
  };

  recreatePreview = () => {
    this.preferences.margins = [];
    for (let i = 0; i < 4; i++) {
      this.preferences.margins.push(this.margins);
    }
    this.generatePdfPreview();
  };

  generatePdfPreview = () => {
    this.indicators = {
      recreating: { progress: true },
    };

    this.pdfQuery.preferences = this.preferences;
    this.documentExporterService
      .exportPdfV2(this.pdfQuery)
      .then((pdfStringResponse) => {
        this.createPdfFromString(pdfStringResponse);
        delete this.indicators.recreating;
      })
      .catch((error) => {
        this.indicators.recreating = { error };
      });
  };

  toggleLandscapeMode = () => {
    this.preferences.isLandscape = !this.preferences.isLandscape;
    this.recreatePreview();
  };

  resetIndicator = () => {
    this.indicators.recreating = null;
  };

  createPdfFromString = (pdfString: string) => {
    const generatedPdf = new Blob([pdfString], { type: "application/pdf" });
    const pdfLink = `${URL.createObjectURL(generatedPdf)}#toolbar=0`;
    this.pdfLink = pdfLink;
    this.pdfFile = generatedPdf;
  };
}

export const PdfPreviewComponent: IComponentOptions = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  controller: PdfPreviewCtrl,
  templateUrl: require("./pdf-preview.jade"),
};
